// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1GgBs","dragIcon":"SortableItem_dragIcon__2g2Lm","disabled":"SortableItem_disabled__1a8pY"};